import { render, staticRenderFns } from "./PricingTerm.vue?vue&type=template&id=11cbdea0&scoped=true&"
import script from "./PricingTerm.vue?vue&type=script&lang=js&"
export * from "./PricingTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cbdea0",
  null
  
)

export default component.exports